import { render, staticRenderFns } from "./capacitaciones.vue?vue&type=template&id=c68c60c8"
import script from "./capacitaciones.vue?vue&type=script&lang=js"
export * from "./capacitaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports